module.exports = __webpack_public_path__ + "img/41.b38bddc8.jpg";